import graphql from "babel-plugin-relay/macro";
import { useMutation } from "react-relay";

import {
  AssignDraftPackageToMemberInput,
  useAssignDraftMemberPackageMutation,
  useAssignDraftMemberPackageMutation$data,
} from "./__generated__/useAssignDraftMemberPackageMutation.graphql";

export const useAssignDraftMemberPackage = () => {
  const [assignDraftMemberPackageMutation, isAssigning] =
    useMutation<useAssignDraftMemberPackageMutation>(
      useAssignDraftMemberPackageMutationString
    );

  const assignDraftMemberPackage = (
    input: AssignDraftPackageToMemberInput,
    onComplete?: (response: useAssignDraftMemberPackageMutation$data) => void,
    onError?: (error: Error) => void
  ) => {
    assignDraftMemberPackageMutation({
      variables: { input },
      onCompleted: (res) => {
        if (res.assignDraftPackageToMember?.success) {
          onComplete && onComplete(res);
        } else {
          const error = new Error(
            res.assignDraftPackageToMember?.errors?.[0]?.message ||
              "Unknown error"
          );
          if (onError) {
            onError(error);
          }
        }
      },
      onError: (error) => {
        if (onError) {
          onError(error);
        }
      },
    });
  };

  return [assignDraftMemberPackage, isAssigning] as const;
};

const useAssignDraftMemberPackageMutationString = graphql`
  mutation useAssignDraftMemberPackageMutation(
    $input: AssignDraftPackageToMemberInput!
  ) {
    assignDraftPackageToMember(input: $input) {
      memberPackage {
        id
        orders {
          edges {
            node {
              id
              packageDueDate
            }
          }
        }
        package {
          billingType
        }
      }
      success
      errors {
        code
        field
        message: code
      }
    }
  }
`;
